'use client'

import {useState, useEffect} from 'react'
import {usePathname} from 'next/navigation'
import Spinner from '@app/icons/spinner'

const RouterNavigationSpinner = () => {
  const [isLoading, setIsLoading] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const anchor = (event.target as HTMLElement).closest('a')

      if (!anchor) return
      // Prevent spinner for:
      // 1. External links
      // 2. Links with target attribute (new tab/window)
      // 3. Special protocol links
      // 4. Links opened with modifier keys (Ctrl/Cmd)
      // 5. Links to the current page
      if (
        anchor.target ||
        event.ctrlKey ||
        event.metaKey ||
        anchor.hostname !== window.location.hostname ||
        !['http:', 'https:'].includes(anchor.protocol) ||
        anchor.pathname === window.location.pathname
      ) {
        return
      }

      setIsLoading(true)
    }

    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  useEffect(() => {
    setIsLoading(false)
  }, [pathname])

  if (!isLoading) return null

  return (
    <div className='fixed top-0 left-0 w-full h-full backdrop-blur flex justify-center items-center lg:z-5 z-20'>
      <Spinner className='w-45 h-45' />
    </div>
  )
}

export default RouterNavigationSpinner
